module.exports = __webpack_public_path__ + "img/TG.7bb0387a.svg";